import reduxStore from '@/features/app/stores/app-store';
import { useDispatch } from 'react-redux';

export type AppDispatch = typeof reduxStore.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
